import React, { useEffect, useState } from 'react';
import { Modal } from '../ui';
import type { PlatformTenant } from './TenantAccordionItem';

type SuspendTenantDialogProps = {
  tenant: PlatformTenant | null;
  isSubmitting?: boolean;
  onClose: () => void;
  onConfirm: (payload: { isActive: boolean; reason?: string }) => void;
};

export const SuspendTenantDialog: React.FC<SuspendTenantDialogProps> = ({
  tenant,
  onClose,
  onConfirm,
  isSubmitting
}) => {
  const [reason, setReason] = useState('');
  const open = Boolean(tenant);

  useEffect(() => {
    if (open) setReason('');
  }, [open]);

  if (!tenant) return null;
  const isSuspending = tenant.isActive;

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      title={isSuspending ? 'Suspender funeraria' : 'Reactivar funeraria'}
    >
      <div className="space-y-4">
        <p className="text-sm text-slate-700">
          {isSuspending
            ? `Se bloqueará el acceso regular de ${tenant.name} hasta reactivarla.`
            : `Se restaurará el acceso de ${tenant.name} para sus usuarios.`}
        </p>
        <div>
          <label className="mb-1 block text-xs font-medium text-slate-600">Motivo (opcional)</label>
          <textarea
            rows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
            placeholder={isSuspending ? 'Ej. morosidad, revisión de seguridad…' : 'Ej. validación completada'}
          />
        </div>
        <div className="flex justify-end gap-2">
          <button
            type="button"
            className="rounded-lg px-4 py-2 text-sm text-slate-600 hover:bg-slate-100"
            onClick={onClose}
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={() => onConfirm({ isActive: !tenant.isActive, reason: reason || undefined })}
            disabled={isSubmitting}
            className={`rounded-lg px-4 py-2 text-sm font-semibold text-white disabled:opacity-60 ${
              isSuspending ? 'bg-rose-700 hover:bg-rose-600' : 'bg-emerald-700 hover:bg-emerald-600'
            }`}
          >
            {isSubmitting ? 'Guardando…' : isSuspending ? 'Suspender' : 'Reactivar'}
          </button>
        </div>
      </div>
    </Modal>
  );
};
